/* DROCER theme v2 — vanilla, no dependencies */
(() => {
  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- money ---------- */
  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = (Number(cents) / 100);
    const withDelim = (num, dec = 2, th = ',', d = '.') => {
      const [a, b] = num.toFixed(dec).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? d + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withDelim(n, 0);
      if (k === 'amount_with_comma_separator') return withDelim(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelim(n, 0, '.');
      return withDelim(n, 2);
    }).replace(/\.00(?!\d)/, '');
  };
  window.theme.formatMoney = formatMoney;

  /* ---------- overlays (drawers, scrim, scroll lock) ---------- */
  const scrim = $('[data-scrim]');
  let openEl = null;
  const openOverlay = (el, trigger) => {
    if (!el) return;
    if (openEl && openEl !== el) closeOverlay(false);
    openEl = el;
    el._trigger = trigger || document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add('is-open');
      if (scrim && !el.hasAttribute('data-no-scrim')) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-on')); }
    });
    document.body.classList.add('is-locked');
    el.setAttribute('aria-hidden', 'false');
    const f = $('[data-autofocus]', el) || $('button, a, input', el);
    setTimeout(() => f && f.focus({ preventScroll: true }), 350);
  };
  const closeOverlay = (restore = true) => {
    if (!openEl) return;
    const el = openEl;
    openEl = null;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-on'); setTimeout(() => { if (!openEl) scrim.hidden = true; }, 500); }
    document.body.classList.remove('is-locked');
    if (restore && el._trigger) el._trigger.focus({ preventScroll: true });
  };
  window.theme.openOverlay = openOverlay;
  window.theme.closeOverlay = closeOverlay;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) { e.preventDefault(); openOverlay(target, opener); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target === scrim) { e.preventDefault(); closeOverlay(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeOverlay(); closeHotspots(); } });

  /* ---------- preloader ---------- */
  const pre = $('[data-preloader]');
  const firstVisit = (() => { try { const v = sessionStorage.getItem('drc-seen'); sessionStorage.setItem('drc-seen', '1'); return !v; } catch (_) { return true; } })();
  const finishPre = () => {
    if (!pre) return;
    pre.classList.add('is-done');
    setTimeout(() => pre.classList.add('is-gone'), 1100);
    document.documentElement.classList.add('is-ready');
  };
  if (pre) {
    if (!firstVisit || reduce) { pre.classList.add('is-gone'); document.documentElement.classList.add('is-ready'); }
    else {
      const c = $('[data-preloader-count]', pre);
      const start = performance.now(), dur = 1100;
      const tick = (t) => {
        const p = Math.min(1, (t - start) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        if (c) c.textContent = String(Math.round(eased * 100)).padStart(2, '0');
        if (p < 1) requestAnimationFrame(tick); else finishPre();
      };
      requestAnimationFrame(tick);
      setTimeout(finishPre, 2600); // hard cap
    }
  } else document.documentElement.classList.add('is-ready');

  /* ---------- split text ---------- */
  $$('[data-split]').forEach((el) => {
    if (el.dataset.splitDone) return;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('w')) walk(n);
      });
    };
    walk(el);
    $$('.w > span', el).forEach((s, i) => s.style.setProperty('--i', i));
    el.dataset.splitDone = '1';
  });

  /* ---------- reveal ---------- */
  const revealEls = $$('[data-reveal], [data-split], [data-mask]');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => {
      if (el.hasAttribute('data-mask') && el.parentElement) {
        const parent = el.parentElement;
        const pio = new IntersectionObserver(([en]) => { if (en.isIntersecting) { el.classList.add('is-in'); pio.disconnect(); } }, { threshold: 0 });
        pio.observe(parent);
      } else io.observe(el);
    });
  } else revealEls.forEach((el) => el.classList.add('is-in'));

  /* ---------- header ---------- */
  const hw = $('[data-header]');
  let lastY = scrollY;
  const onScrollHeader = () => {
    if (!hw) return;
    const y = scrollY;
    hw.classList.toggle('is-scrolled', y > 40);
    const hidden = y > 400 && y > lastY + 4 && !openEl;
    if (y < lastY - 4 || y < 400) hw.classList.remove('is-hidden');
    else if (hidden) hw.classList.add('is-hidden');
    lastY = y;
  };

  /* ---------- parallax + hero ---------- */
  const para = $$('[data-parallax]');
  const hero = $('[data-hero]');
  const heroMedia = hero && $('.hero__media', hero);
  let ticking = false;
  const onScrollFx = () => {
    ticking = false;
    const vh = innerHeight;
    if (!reduce) {
      para.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const speed = parseFloat(el.dataset.parallax) || 0.1;
        const mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = `translate3d(0, ${(-mid * speed).toFixed(1)}px, 0)`;
      });
      if (heroMedia) {
        const r = hero.getBoundingClientRect();
        if (r.bottom > 0) {
          const p = Math.min(1, Math.max(0, -r.top / r.height));
          heroMedia.style.transform = `translate3d(0, ${(p * r.height * 0.35).toFixed(1)}px, 0) scale(${(1 + p * 0.08).toFixed(3)})`;
        }
      }
    }
  };
  addEventListener('scroll', () => {
    onScrollHeader();
    if (!ticking) { ticking = true; requestAnimationFrame(onScrollFx); }
  }, { passive: true });
  onScrollHeader(); onScrollFx();

  /* ---------- hero video: play when visible, lazy src ---------- */
  $$('video[data-autoplay]').forEach((v) => {
    const io = new IntersectionObserver(([en]) => {
      if (en.isIntersecting) {
        if (!v.src && v.dataset.src) {
          v.src = v.dataset.src;
          if (v.dataset.start) v.addEventListener('loadedmetadata', () => { try { v.currentTime = parseFloat(v.dataset.start) % (v.duration || 999); } catch (_) {} }, { once: true });
        }
        v.play().catch(() => {});
      } else v.pause();
    }, { threshold: 0.05 });
    io.observe(v);
  });

  /* ---------- magnetic + cursor ---------- */
  if (fine && !reduce) {
    $$('[data-magnetic]').forEach((el) => {
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.25;
        const y = (e.clientY - r.top - r.height / 2) * 0.35;
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
      el.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
    const cur = $('[data-cursor]');
    if (cur) {
      let cx = 0, cy = 0, tx = 0, ty = 0;
      addEventListener('mousemove', (e) => { tx = e.clientX; ty = e.clientY; cur.classList.add('is-on'); }, { passive: true });
      document.addEventListener('mouseleave', () => cur.classList.remove('is-on'));
      const loop = () => { cx += (tx - cx) * 0.22; cy += (ty - cy) * 0.22; cur.style.transform = `translate(${cx}px, ${cy}px)`; requestAnimationFrame(loop); };
      loop();
      document.addEventListener('mouseover', (e) => { cur.classList.toggle('is-big', !!e.target.closest('.card__media, .tile, .look-img, [data-cursor-big]')); });
    }
  }

  /* ---------- rails ---------- */
  $$('[data-rail]').forEach((wrap) => {
    const rail = $('.rail', wrap);
    const bar = $('.rail-progress span', wrap);
    if (!rail) return;
    const upd = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const vis = rail.clientWidth / rail.scrollWidth;
      if (bar) { bar.style.width = (vis * 100) + '%'; bar.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * ((1 / vis) - 1) * 100 : 0}%)`; }
    };
    rail.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    $$('[data-rail-prev], [data-rail-next]', wrap).forEach((b) => b.addEventListener('click', () => {
      const card = rail.firstElementChild; const step = card ? card.getBoundingClientRect().width + 20 : 300;
      rail.scrollBy({ left: b.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
    }));
  });

  /* ---------- hotspots ---------- */
  const closeHotspots = () => { $$('.hotspot[aria-expanded="true"]').forEach((h) => h.setAttribute('aria-expanded', 'false')); $$('.hotspot-card.is-open').forEach((c) => c.classList.remove('is-open')); };
  document.addEventListener('click', (e) => {
    const h = e.target.closest('.hotspot');
    if (!h) { if (!e.target.closest('.hotspot-card')) closeHotspots(); return; }
    const card = document.getElementById(h.getAttribute('aria-controls'));
    const was = h.getAttribute('aria-expanded') === 'true';
    closeHotspots();
    if (was || !card) return;
    h.setAttribute('aria-expanded', 'true');
    const box = h.closest('.stl').getBoundingClientRect();
    const r = h.getBoundingClientRect();
    let left = r.left - box.left + 26, top = r.top - box.top - 20;
    if (left + 260 > box.width) left = r.left - box.left - 260;
    if (left < 10) left = 10;
    if (top + 130 > box.height) top = box.height - 140;
    card.style.left = left + 'px'; card.style.top = Math.max(10, top) + 'px';
    card.classList.add('is-open');
  });

  /* ---------- toast ---------- */
  let toastT;
  const toast = (msg) => {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast mono'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  /* ---------- cart ---------- */
  const cartDrawer = () => document.getElementById('CartDrawer');
  const SECTIONS = 'cart-drawer';
  const renderSections = (sections) => {
    if (!sections) return;
    const html = sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const count = $('[data-cart-count-src]', doc);
      if (count) $$('[data-cart-count]').forEach((c) => { c.textContent = count.dataset.count; c.dataset.count = count.dataset.count; });
      const next = $('[data-cart-inner]', doc);
      const cur = $('[data-cart-inner]');
      if (next && cur) { cur.replaceWith(next); $$('[data-reveal]', next).forEach((n) => n.classList.add('is-in')); }
    }
  };
  const addToCart = async (items, btn) => {
    const label = btn && btn.querySelector('[data-label]');
    const orig = label && label.textContent;
    if (btn) { btn.classList.add('is-loading'); if (label) label.textContent = T.strings.adding; }
    try {
      const res = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: SECTIONS, sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
      renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      openOverlay(cartDrawer());
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); if (label) label.textContent = orig; }
    }
  };
  window.theme.addToCart = addToCart;

  const changeLine = async (line, quantity) => {
    const inner = $('[data-cart-inner]'); inner && inner.classList.add('is-loading');
    try {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTIONS, sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update');
      renderSections(data.sections);
      if (document.body.classList.contains('template-cart')) location.reload();
    } catch (err) { toast(err.message); inner && inner.classList.remove('is-loading'); }
  };

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-btn]');
    if (q) {
      const wrap = q.closest('[data-line]');
      const input = $('input', wrap);
      const v = Math.max(0, (parseInt(input.value, 10) || 0) + (q.dataset.qtyBtn === 'plus' ? 1 : -1));
      input.value = v; changeLine(parseInt(wrap.dataset.line, 10), v); return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.remove, 10), 0); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line] input');
    if (input) changeLine(parseInt(input.closest('[data-line]').dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- product form ---------- */
  const isSizeName = (n) => /size|taille|talla/i.test(n);
  $$('[data-product]').forEach((root) => {
    const json = $('[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const btn = form && $('[data-atc]', form);
    const btnLabel = btn && $('[data-label]', btn);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);
    const sticky = $('[data-sticky-atc]');
    const inv = JSON.parse(($('[data-inventory]', root) || {}).textContent || '{}');
    const optCount = product.options.length;
    let chosen = [];

    const current = () => $$('[data-option]', root).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (vals) => product.variants.find((v) => v.options.every((o, i) => vals[i] === o));

    const updateAvailability = (vals) => {
      $$('[data-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = vals.slice(); test[idx] = inp.value;
          const any = product.variants.some((v) => v.available && v.options.every((o, i) => i === idx ? o === inp.value : (test[i] == null || test[i] === o)));
          const lbl = inp.nextElementSibling; if (lbl) lbl.classList.toggle('is-out', !any);
        });
      });
    };

    const setStock = (v) => {
      if (!stockEl) return;
      if (!v) { stockEl.hidden = true; return; }
      stockEl.hidden = false;
      const q = inv[v.id];
      stockEl.className = 'stock mono';
      if (!v.available) { stockEl.classList.add('stock--out'); stockEl.textContent = T.strings.soldOut; }
      else if (typeof q === 'number' && q > 0 && q <= 5) { stockEl.classList.add('stock--low'); stockEl.textContent = `Only ${q} left in this size — add to bag to grab it`; }
      else stockEl.textContent = 'In stock — ships tracked';
    };

    const update = (fromUser) => {
      chosen = current();
      const missing = chosen.some((v) => v == null);
      $$('[data-option]', root).forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = chosen[i] || ''; });
      updateAvailability(chosen);
      const v = missing ? null : findVariant(chosen);
      if (idInput) idInput.value = v ? v.id : '';
      if (btn) {
        const ok = v && v.available;
        btn.disabled = !ok;
        btn.classList.toggle('is-disabled', !ok);
        if (btnLabel) btnLabel.textContent = missing ? T.strings.selectSize : (!v ? T.strings.unavailable : (v.available ? T.strings.addToBag : T.strings.soldOut));
      }
      if (priceEl && v) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '') + `<span>${formatMoney(v.price)}</span>`;
      }
      if (sticky) {
        const sBtn = $('[data-sticky-btn]', sticky); const sPrice = $('[data-sticky-price]', sticky);
        if (sPrice && v) sPrice.textContent = formatMoney(v.price);
        if (sBtn) $('[data-label]', sBtn).textContent = missing ? T.strings.selectSize : (v && v.available ? T.strings.addToBag : T.strings.soldOut);
      }
      setStock(v);
      const bis = $('[data-bis]', root);
      if (bis) {
        const out = !!(v && !v.available);
        bis.hidden = !out;
        const tags = $('[data-bis-tags]', bis);
        if (tags && v) tags.value = `${tags.dataset.base}, bis-variant-${v.id}, bis-${(v.title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
      }
      if (v && fromUser) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
        if (v.featured_media) {
          const slide = $(`[data-media-id="${v.featured_media.id}"]`, root);
          const slides = $('.pdp__slides', root);
          if (slide && slides) {
            if (matchMedia('(min-width: 990px)').matches) { /* stacked on desktop: leave */ }
            else slides.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
        }
      }
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) update(true); });
    update(false);

    if (form) form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!idInput.value) {
        const firstMissing = $$('[data-option]', root).find((fs) => !$('input:checked', fs));
        if (firstMissing) { firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstMissing.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 320 }); }
        toast(T.strings.selectSize); return;
      }
      const fd = new FormData(form);
      const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
      addToCart([{ id: Number(idInput.value), quantity: Number(fd.get('quantity') || 1), properties: props }], btn);
    });

    /* gallery dots */
    const slides = $('.pdp__slides', root);
    const dots = $$('.pdp__dots span', root);
    const counter = $('[data-slide-count]', root);
    if (slides) slides.addEventListener('scroll', () => {
      const i = Math.round(slides.scrollLeft / slides.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
      if (counter) counter.textContent = i + 1;
    }, { passive: true });

    /* sticky ATC */
    if (sticky && btn) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(btn);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        if (idInput.value) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        else { const fs = $$('[data-option]', root).find((f) => !$('input:checked', f)) || $('[data-option]', root); fs && fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    }
  });

  /* ---------- recommendations (async) ---------- */
  $$('[data-recs]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.recs);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = $('[data-recs]', doc);
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; $$('[data-reveal]', el).forEach((n) => n.classList.add('is-in')); }
      else el.closest('.section')?.remove();
    } catch (_) {}
  });

  /* ---------- predictive search ---------- */
  const sInput = $('[data-search-input]');
  const sOut = $('[data-search-results]');
  if (sInput && sOut) {
    let t, ctrl;
    sInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = sInput.value.trim();
      if (!q) { sOut.innerHTML = sOut.dataset.empty || ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const res = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=10&section_id=predictive-search`, { signal: ctrl.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('[data-predictive]', doc);
          sOut.innerHTML = inner ? inner.innerHTML : '';
          $$('[data-reveal]', sOut).forEach((n) => n.classList.add('is-in'));
        } catch (_) {}
      }, 180);
    });
    if (sOut.innerHTML.trim()) sOut.dataset.empty = sOut.innerHTML;
  }

  /* ---------- collection sort + filters ---------- */
  const sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u; });
  const filterForm = $('[data-filter-form]');
  if (filterForm) filterForm.addEventListener('change', () => {
    const u = new URL(location.pathname, location.origin);
    const fd = new FormData(filterForm);
    for (const [k, v] of fd.entries()) if (v !== '') u.searchParams.append(k, v);
    const sb = new URL(location.href).searchParams.get('sort_by'); if (sb) u.searchParams.set('sort_by', sb);
    location.href = u;
  });


  /* ---------- 3D showcase: load Three.js only when near viewport ---------- */
  $$('[data-showcase]').forEach((root) => {
    const io = new IntersectionObserver(async ([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      try { const m = await import(root.dataset.module); m.mount(root); }
      catch (err) { root.classList.add('is-ready'); console.warn('3D showcase unavailable', err); }
    }, { rootMargin: '400px 0px' });
    io.observe(root);
  });

  /* ---------- smooth scroll (desktop, fine pointer only) ---------- */
  if (fine && !reduce && !document.body.classList.contains('template-product-noscroll')) {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js';
    s.onload = () => {
      if (!window.Lenis) return;
      const lenis = new window.Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
      window.theme.lenis = lenis;
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
      // pause while drawers are open so they scroll themselves
      new MutationObserver(() => { document.body.classList.contains('is-locked') ? lenis.stop() : lenis.start(); })
        .observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a || a.getAttribute('href').length < 2) return;
        const t = document.querySelector(a.getAttribute('href'));
        if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -80 }); }
      });
    };
    document.head.appendChild(s);
  }

  /* ---------- seamless product transition (View Transitions API) ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.card a[href*="/products/"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const img = a.closest('.card').querySelector('.card__media img.img-main');
    if (img) img.style.viewTransitionName = 'pdp-hero';
  });
  window.addEventListener('pageshow', () => { $$('.card__media img').forEach((i) => (i.style.viewTransitionName = '')); });

  /* ---------- 3D tilt on product cards ---------- */
  if (fine && !reduce) {
    document.addEventListener('pointermove', (e) => {
      const m = e.target.closest && e.target.closest('.card__top');
      $$('.card__top.is-tilt').forEach((c) => { if (c !== m) { c.classList.remove('is-tilt'); c.style.transform = ''; } });
      if (!m) return;
      const r = m.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      m.classList.add('is-tilt');
      m.style.transform = `perspective(900px) rotateY(${(x * 7).toFixed(2)}deg) rotateX(${(-y * 7).toFixed(2)}deg)`;
      m.style.setProperty('--sx', `${((x + 0.5) * 100).toFixed(1)}%`);
      m.style.setProperty('--sy', `${((y + 0.5) * 100).toFixed(1)}%`);
    }, { passive: true });
  }

  /* ---------- countdown (Toronto time) ---------- */
  $$('[data-countdown]').forEach((root) => {
    const raw = root.dataset.when; if (!raw) return;
    // treat input as America/Toronto wall-clock time
    const torontoOffset = (d) => { const s = d.toLocaleString('en-US', { timeZone: 'America/Toronto', timeZoneName: 'shortOffset' }); const m = s.match(/GMT([+-]\d+)(?::(\d+))?/); return m ? (parseInt(m[1], 10) * 60 + Math.sign(parseInt(m[1], 10)) * (parseInt(m[2] || '0', 10))) : -240; };
    const naive = new Date(raw + (raw.length <= 16 ? ':00' : '') + 'Z');
    const target = new Date(naive.getTime() - torontoOffset(naive) * 60000);
    const el = (k) => $(`[data-${k}]`, root);
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const ms = target - Date.now();
      if (ms <= 0) { el('before').hidden = true; el('after').hidden = false; el('clock').classList.add('is-live'); ['d', 'h', 'm', 's'].forEach((k) => (el(k).textContent = '00')); return; }
      const s = Math.floor(ms / 1000);
      el('d').textContent = pad(Math.floor(s / 86400)); el('h').textContent = pad(Math.floor((s % 86400) / 3600));
      el('m').textContent = pad(Math.floor((s % 3600) / 60)); el('s').textContent = pad(s % 60);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    tick();
  });

  /* ---------- marquee: scroll-velocity speed + RECORD→DROCER flip ---------- */
  if (!reduce) {
    const rows = $$('.marquee__row');
    let last = scrollY, v = 0;
    const mq = () => {
      const d = scrollY - last; last = scrollY; v += (d - v) * 0.1;
      const k = 1 + Math.min(4, Math.abs(v) * 0.08);
      rows.forEach((r) => { r.getAnimations().forEach((a) => { a.playbackRate = (r.classList.contains('marquee__row--rev') ? 1 : 1) * k * (v < -0.5 ? -1 : 1); }); });
      $$('.marquee').forEach((m) => {
        const rct = m.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, 1 - (rct.top + rct.height / 2) / innerHeight));
        const flip = -Math.cos(Math.min(1, Math.max(0, (p - 0.35) / 0.3)) * Math.PI); // 1 → -1 as it passes mid-screen
        m.style.setProperty('--flip', flip.toFixed(3));
      });
      requestAnimationFrame(mq);
    };
    requestAnimationFrame(mq);
  }

  /* ---------- lookbook image trail (desktop) ---------- */
  if (fine && !reduce) {
    $$('[data-trail]').forEach((zone) => {
      const srcs = $$('img', zone.closest('section')).map((i) => i.currentSrc || i.src).filter(Boolean).slice(0, 12);
      if (!srcs.length) return;
      let lx = 0, ly = 0, idx = 0;
      zone.addEventListener('mousemove', (e) => {
        if (Math.hypot(e.clientX - lx, e.clientY - ly) < 90) return;
        lx = e.clientX; ly = e.clientY;
        const r = zone.getBoundingClientRect();
        const im = document.createElement('img');
        im.src = srcs[idx++ % srcs.length]; im.className = 'trail-img'; im.alt = '';
        im.style.left = (e.clientX - r.left) + 'px'; im.style.top = (e.clientY - r.top) + 'px';
        im.style.setProperty('--r', ((Math.random() - 0.5) * 16).toFixed(1) + 'deg');
        zone.appendChild(im);
        setTimeout(() => im.remove(), 1100);
      });
    });
  }

  /* ---------- "your bag is waiting" for returning visitors ---------- */
  (() => {
    const n = parseInt(($('[data-cart-count]') || {}).dataset?.count || '0', 10);
    if (!n || document.body.classList.contains('template-cart')) return;
    let seen = false; try { seen = sessionStorage.getItem('drc-bag-nudge'); sessionStorage.setItem('drc-bag-nudge', '1'); } catch (_) {}
    if (seen) return;
    setTimeout(() => {
      const pill = document.createElement('button');
      pill.type = 'button'; pill.className = 'bag-nudge mono';
      pill.innerHTML = `<span class="live-dot">${T.strings.bagWaiting.replace('{n}', n)}</span><b>${T.strings.bagView}</b>`;
      pill.addEventListener('click', () => { pill.remove(); openOverlay(document.getElementById('CartDrawer')); });
      document.body.appendChild(pill);
      requestAnimationFrame(() => pill.classList.add('is-on'));
      setTimeout(() => { pill.classList.remove('is-on'); setTimeout(() => pill.remove(), 600); }, 9000);
    }, 2500);
  })();

  /* ---------- real "just bought" pop-ups (only from actual orders) ---------- */
  (() => {
    const src = $('[data-recent-sales]'); if (!src) return;
    let sales = []; try { sales = JSON.parse(src.textContent); } catch (_) { return; }
    if (!sales.length) return;
    let shown = 0; try { shown = parseInt(sessionStorage.getItem('drc-pops') || '0', 10); } catch (_) {}
    if (shown >= 3) return;
    sales.sort((a, b) => b.t - a.t);
    const ago = (t) => { const m = Math.max(1, Math.round((Date.now() / 1000 - t) / 60)); if (m < 60) return m + ' min ago'; const h = Math.round(m / 60); if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago'); const d = Math.round(h / 24); return d + (d === 1 ? ' day ago' : ' days ago'); };
    let i = 0;
    const pop = () => {
      if (shown >= 3 || document.body.classList.contains('is-locked')) return;
      const s = sales[i++ % sales.length];
      const el = document.createElement('a');
      el.className = 'sale-pop'; el.href = s.url;
      el.innerHTML = `<img src="${s.img}" alt="" width="56" height="70"><span><small class="mono">${T.strings.justBought.replace('{city}', s.city)}</small><b>${s.title}</b><small class="mono" style="opacity:.6">${ago(s.t)} · ${T.strings.verifiedOrder}</small></span>`;
      document.body.appendChild(el);
      requestAnimationFrame(() => el.classList.add('is-on'));
      setTimeout(() => { el.classList.remove('is-on'); setTimeout(() => el.remove(), 700); }, 6500);
      shown++; try { sessionStorage.setItem('drc-pops', String(shown)); } catch (_) {}
      if (shown < 3 && i < sales.length + 1) setTimeout(pop, 28000);
    };
    setTimeout(pop, 12000);
  })();

  /* ---------- newsletter: reveal success if posted ---------- */
  if (location.search.includes('customer_posted=true')) $$('[data-signup-ok]').forEach((el) => (el.hidden = false));
})();
